import * as React from 'react'
import {ComponentExt} from '@utils/reactExt'
import * as styles from './style/index.scss'
import {InputItem, WhiteSpace} from 'antd-mobile'
import {FormattedMessage} from 'react-intl'
import {homeStoreG} from '@viewsG/home/actor/store'
import intl from '@utils/intl';

class AccountInfo extends ComponentExt<any, any> {
    constructor(props) {
        super(props)
        this.state = {
            userInfo: null
        }
    }

    async componentDidMount() {
        const userInfo = await homeStoreG.getUserInfo()
        if (!userInfo) {
            location.href = '#/global/login'
            return
        }
        this.setState({
            userInfo: userInfo,
            nickName: userInfo.laoCustomerDto.nickName
        })
    }

    doCancel = () => {
        this.setState({
            nickName: this.state.userInfo.laoCustomerDto.nickName
        })
    }

    doContinue = async () => {
        if (!this.state.nickName || this.state.nickName.length < 4 || this.state.nickName.length > 20) {
            this.$toast.info(intl.formatMessage({id: 'account.errorNickname'}))
            return false
        }
        try {
            await this.api.updateCustomerNickName({nickName: this.state.nickName})
            this.$toast.info(intl.formatMessage({id: 'common.success'}))
        } catch (e) {}
    }

    render() {
        if (!this.state.userInfo) {
            return <></>
        }
        return (
            <div className={styles.accountInfoWrap}>
                <p><FormattedMessage id="account.account.fieldTitle"/></p>
                <InputItem className={styles.inputItem} disabled value={this.state.userInfo.lenovoId}/>
                <WhiteSpace/>
                <p><FormattedMessage id="account.nickName.fieldTitle"/></p>
                <InputItem
                    className={`${styles.inputItem} ${styles.inputNickname}`}
                    value={this.state.nickName}
                    onChange={e => this.setState({nickName: e})}
                />
                <span className={styles.tip}><FormattedMessage id="account.nickName.character"/></span>
                <section className={styles.btnWrap}>
                    <div className={styles.cancelBtn} onClick={this.doCancel}>
                        <FormattedMessage id="common.cancel"/>
                    </div>
                    <div className={styles.continueBtn} onClick={this.doContinue}>
                        <FormattedMessage id="common.save"/>
                    </div>
                </section>
            </div>
        )
    }
}

export default AccountInfo
